<template>
  <div>
    <button
      type="button"
      v-if="canDestroy"
      class="border border-red-600 text-sm font-medium p-2 my-2 mx-1 rounded-md shadow-sm text-red-600 bg-gray-100 hover:bg-red-600 hover:text-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-600"
      @click="actionSelected(params.options.destroyAction)"
    >
      Destroy
    </button>
    <button
      type="button"
      v-if="canUndo"
      class="text-sm underline font-medium p-2 my-2 mx-1 text-blue-600 hover:text-blue-400 focus:outline-none"
      @click="actionSelected(params.options.cancelAction)"
    >
      Undo
    </button>
    <div
      v-if="isDestroyed"
      class="text-red-600"
    >
      <p>Destroyed</p>
      <p class="text-sm">{{ formatDate(params.data.destroyed_at) }}</p>
    </div>
    <div
      v-if="isCancelled"
      class="text-gray-600"
    >
      <p>Cancelled</p>
      <p class="text-sm">{{ formatDate(params.data.cancelled_at) }}</p>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import moment from 'moment'

import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'

dayjs.extend(advancedFormat)

/**
 * @typedef {Object} ActionCellParams
 * @property {Array} options
 */
const props = defineProps({
  /** @type {LinkCellParams} */
  params: {
    type: Object,
    required: true
  }
})

const canUndo = computed(() => {
  return props.params.data.destroyable_at !== null && !isDestroyed.value && !isCancelled.value
})

const canDestroy = computed(() => {
  return moment(props.params.data.destroyable_at).isBefore(moment.now()) && !isDestroyed.value && !isCancelled.value
})

const isDestroyed = computed(() => {
  return props.params.data.destroyed_at !== null
})

const isCancelled = computed(() => {
  return props.params.data.cancelled_at !== null
})

const actionSelected = (action) => {
  props.params.context.actionFunction(action, props.params.data)
}

const formatDate = (date) => {
  return dayjs(date).format('MM/DD/YYYY hh:mmA')
}
</script>
